import Spin from 'antd/lib/spin';
import { FaFileCsv } from 'react-icons/fa/index.esm';
import { HiCheckCircle } from 'react-icons/hi/index.esm';
import { RiCloseCircleFill } from 'react-icons/ri/index.esm';

import ColumnMapping from 'components/ImportCsv/StepsComponents/ColumnMappingStep';
import Final from 'components/ImportCsv/StepsComponents/FinalStep';
import SyncVariations from 'components/ImportCsv/StepsComponents/SyncVariationsStep';
import ImportCsvFile from 'components/ImportCsv/StepsComponents/UploadCsvStep/UploadCsvStep';

export enum EImportFileStatuses {
  Initial = 'initial',
  Uploading = 'uploading',
  FileTypeError = 'fileTypeError',
  Success = 'success',
  Error = 'error'
}

export enum EFinalStatuses {
  Success = 'success',
  Error = 'error',
}

export interface IStepComponentProps {
  step: number,
  setStep: (step: number) => void,
  fileColumns?: string[],
  setFileColumns?: (fileColumns: string[]) => void
  finalStatus?: EFinalStatuses,
}

export const headerSteps = ['Upload CSV', 'Column Mapping', 'Choose Variation', 'Done'];

export const stepContent = [ImportCsvFile, ColumnMapping, SyncVariations, Final];

export const csvFormatColumns = [
  'Product ID',
  'Product title',
  'Site name',
  'Image URL',
  'Description',
  'Shipping price',
  'Retail price',
  'Brand',
  'UPC',
  'Length',
  'Width',
  'Height',
];

export const csvUploadContentByStatus = {
  [EImportFileStatuses.Initial]:
    <>
      <FaFileCsv className="blue" size={35} />
      <p className="blue m-t-5 m-b-5">Drop CSV file</p>
      <p className="regular">Or select file from your computer</p>
    </>,
  [EImportFileStatuses.Uploading]:
    <>
      <Spin size="large" />
      <p className="m-t-5">Processing CSV</p>
    </>,
  [EImportFileStatuses.FileTypeError]: <>
    <RiCloseCircleFill size={50} color="var(--danger)" />
    <p className="danger semi-bold m-t-5">Only CSV format</p>
    <p className="regular clickable blue">Please try one more time</p>
  </>,
  [EImportFileStatuses.Success]:
    <>
      <HiCheckCircle size={50} color="var(--success)" />
      <p className="success">File was successfully uploaded</p>
    </>,
  [EImportFileStatuses.Error]:
    <>
      <RiCloseCircleFill size={50} color="var(--danger)" />
      <p className="danger semi-bold m-t-5">Something went wrong</p>
      <p className="regular"><span className="clickable blue semi-bold">Upload</span>&nbsp;on more time</p>
    </>,
};

export const finalContentByStatus = {
  [EFinalStatuses.Success]: <>
    <HiCheckCircle size={50} color="var(--success)" />
    <p className="semi-bold">Your products are uploading</p>
    <p className="regular">You can check it here on </p>
  </>,
  [EFinalStatuses.Error]: <>
    <RiCloseCircleFill size={50} color="var(--danger)" />
    <p>Something went wrong.</p>
    <p className="regular">Please try one more time.</p>
  </>,
};
